/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Select_Drive_FirstInputs */



/**
* | output |
* | --- |
* | "Select Drive First" |
*
* @param {Spaces_Select_Drive_FirstInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_select_drive_first = /** @type {((inputs?: Spaces_Select_Drive_FirstInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Select_Drive_FirstInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Zuerst Laufwerk auswählen")
	return /** @type {LocalizedString} */ ("Select Drive First")
});